import { TripWizard } from "@/components/travels/TripWizard";
import React from "react";
import { useNavigate } from "react-router-dom";

export const TripWizardPage: React.FC = () => {
  const navigate = useNavigate();
  return <TripWizard onClose={() => navigate("/traveler/travels")} />;
};
